import { Injectable } from "@angular/core";
import { Query } from "@datorama/akita";
import { Observable } from "rxjs";
import {
    CitizenIntroductionState,
    CitizenIntroductionSteps,
    CitizenIntroductionStore
} from "./citizen-introduction.store";

@Injectable()
export class CitizenIntroductionQuery extends Query<CitizenIntroductionState> {
    constructor(store: CitizenIntroductionStore) {
        super(store);
    }

    public selectCurrentStep(): Observable<CitizenIntroductionSteps> {
        return this.select("currentStep");
    }
}
